<template>
  <div>
    <li v-if="status.slice(0, 4) !== 'posi' && status.slice(0, 4) !== 'depa' && status.slice(0, 4) !== 'comp'">
      <div :style="handleStyle(model)">
        <van-checkbox v-if="isShow(model)" shape="square" v-model="model.isChecked" @click="onCheck1(model)" />
        <img class="member-avatar" v-if="show1(model)" :src="renderAvatar(model)" />
        <!-- <div class="member-name" v-if="show2(model)">{{renderMemberName(model)}}</div> -->
        <img src="@/assets/default.png" v-if="show2(model)" class="member-avatar" />
        <div :class="[model.type === 2 ? 'item-name' : '']" @click="toggle">
          {{ renderName(model) }}
          <!-- <span v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span> -->
          <img class="display-img" v-if="isFolder && isOpen" src="../assets/up.png" />
          <img class="display-img" v-if="isFolder && !isOpen" src="../assets/down.png" />
        </div>
      </div>
      <ul v-show="isOpen" v-if="isFolder">
        <TreeItem v-for="(model, index) in model.childList" :model="model" :key="index"> </TreeItem>
      </ul>
    </li>
    <li v-if="status.slice(0, 4) === 'posi'">
      <div :style="handlePositionStyle(model)">
        <van-checkbox v-if="isShow(model)" shape="square" v-model="model.isChecked" @click="onCheck2(model)" />
        <!-- <img class="member-avatar" v-if="show1(model)" :src="renderAvatar(model)" /> -->
        <!-- <div class="member-name" v-if="show2(model)">{{model.name}}</div> -->
        <div :class="[model.postFlag === 2 ? 'item-name' : '']" @click="toggle">
          <span>{{ renderPosition(model) }}</span>
          <!-- <span v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span> -->
          <img class="display-img" v-if="isFolder && isOpen" src="../assets/up.png" />
          <img class="display-img" v-if="isFolder && !isOpen" src="../assets/down.png" />
        </div>
      </div>
      <ul v-show="isOpen" v-if="isFolder">
        <TreeItem v-for="(model, index) in model.childList" :model="model" :key="index"> </TreeItem>
      </ul>
    </li>
    <li v-if="status.slice(0, 4) === 'depa'">
      <div :style="handleDepartmentStyle(model)">
        <van-checkbox v-if="isShow(model)" shape="square" v-model="model.isChecked" @click="onCheck3(model)" />
        <!-- <img class="member-avatar" v-if="show1(model)" :src="renderAvatar(model)" /> -->
        <!-- <div class="member-name" v-if="show2(model)">{{renderOfficeName(model)}}</div> -->
        <div :class="[model.officeType === 4 ? 'item-name' : '']" @click="toggle">
          <span>{{ renderDepartment(model) }}</span>
          <!-- <span v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span> -->
          <img class="display-img" v-if="isFolder && isOpen" src="../assets/up.png" />
          <img class="display-img" v-if="isFolder && !isOpen" src="../assets/down.png" />
        </div>
      </div>
      <ul v-show="isOpen" v-if="isFolder">
        <TreeItem v-for="(model, index) in model.childList" :model="model" :key="index"> </TreeItem>
      </ul>
    </li>
    <li v-if="status.slice(0, 4) === 'comp'">
      <div :style="handleCompanyStyle(model)">
        <van-checkbox v-if="showCompany(model)" shape="square" v-model="model.isChecked" @click="onCheck4(model)" />
        <div :class="[model.type === 0 || model.type === 3 ? 'item-name' : '']" @click="toggle">
          <span>{{ renderCompany(model) }}</span>
          <img class="display-img" v-if="isFolder && isOpen" src="../assets/up.png" />
          <img class="display-img" v-if="isFolder && !isOpen" src="../assets/down.png" />
        </div>
      </div>
      <ul v-show="isOpen" v-if="isFolder">
        <TreeItem v-for="(model, index) in model.childList" :model="model" :key="index"> </TreeItem>
      </ul>
    </li>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TreeItem",
  props: {
    model: Object,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isFolder() {
      return this.model?.childList && this.model?.childList.length;
    },
    ...mapState(["selectedList", "status", "initialData", "type", "kitValue"]),
  },
  created() {},

  methods: {
    toggle() {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    show1(model) {
      return model?.avatar && this.isShow(model);
    },
    show2(model) {
      return !model?.avatar && this.isShow(model);
    },
    isShow(model) {
      return model?.postFlag === 2 || model?.type === 2 || model?.officeType === 4;
    },
    showCompany(model) {
      return model?.type === 0 || model?.type === 3;
    },
    renderName(model) {
      // const str = model?.childList?.length > 0 ? `(${model?.childList?.length})` : "";
      const str = model?.type != 2 && model?.staffTotal > 0 ? `(${model?.staffTotal})` : ''
      return model?.name + str;
    },
    renderPosition(model) {
      const str = model?.childList?.length > 0 && model.level !== 2 ? `(${model?.childList?.length})` : "";
      return model?.name;
    },
    renderDepartment(model) {
      const str = model?.childList?.length > 0 && model.level !== 0 ? `(${model?.childList?.length})` : "";
      return model?.name;
    },
    renderCompany(model) {
      return model?.name;
    },
    renderAvatar(model) {
      return model?.avatar;
    },
    renderMemberName(model) {
      let str = model?.name.slice(-2);
      return str;
    },
    renderOfficeName(model) {
      let str = model?.officeName.slice(-2);
      return str;
    },
    handleStyle(model) {
      return {
        "margin-left": `${model?.level * 30}px`,
        display: "flex",
        "margin-top": `${model?.level === 0 ? 0 : 0.56}rem`,
        position: "relative",
      };
    },
    handlePositionStyle(model) {
      return {
        "margin-left": `${(model?.level + 2) * 30}px`,
        display: "flex",
        "margin-top": `${model?.level == -2 ? 0 : 0.56}rem`,
        position: "relative",
      };
    },
    handleDepartmentStyle(model) {
      return {
        "margin-left": `${model?.level * 30}px`,
        display: "flex",
        "margin-top": `${model?.level === 0 ? 0 : 0.56}rem`,
        position: "relative",
      };
    },
    handleCompanyStyle(model) {
      return {
        "margin-left": `${model?.level * 30}px`,
        display: "flex",
        "margin-top": `${model?.level === 0 ? 0 : 0.56}rem`,
        position: "relative",
      };
    },
    onCheck1(model) {
      if (this.type) {
        this.$store.commit("setTransferData", model);
      } else {
        this.$store.commit("setSelectList", model);
      }
      this.getParent(this, Number(model?.level)).$forceUpdate();
    },
    onCheck2(model) {
      this.$store.commit("setSelectList", model);
      this.getParent(this, Number(model?.level + 2)).$forceUpdate();
    },
    onCheck3(model) {
      this.$store.commit("setSelectList", model);
      this.getParent(this, Number(model?.level)).$forceUpdate();
    },
    onCheck4(model) {
      this.$store.commit("setSelectList", {...model,childList: null});
      this.getParent(this, Number(model?.level)).$forceUpdate();
    },
    getParent(l, num) {
      if (num == 0) {
        return l.$parent;
      } else {
        return this.getParent(l.$parent, num - 1);
      }
    },
  },
};
</script>

<style scoped>
li {
  list-style: none;
}
.member-avatar {
  width: 1rem;
  height: 1rem;
  margin-left: 0.24rem;
  border-radius: 0.21rem;
}
.member-name {
  width: 1rem;
  height: 1rem;
  background: #1584ff;
  border-radius: 0.21rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 1rem;
  text-align: center;
  margin-left: 0.24rem;
}
.item-name {
  line-height: 1rem;
  margin-left: 0.21rem;
}
.display-img {
  width: 0.29rem;
  height: 0.19rem;
  position: absolute;
  right: 0;
  bottom: 10px;
}
</style>